import React from "react";
import { useTranslation } from "react-i18next";
import { TooltipCustom } from "@services/ui-components";

interface ContactsFallbackProps {
    tooltipText?: string;
    className?: string;
}

const ContactsFallback: React.FC<ContactsFallbackProps> = ({ tooltipText, className = "text-dark" }) => {
    const { t } = useTranslation();

    return (
        <TooltipCustom placement="top" text={tooltipText || t("Contact details are hidden by access settings")}>
            <span className={className}>**********</span>
        </TooltipCustom>
    );
};

export default ContactsFallback;
